import React from "react";
import './index.css';
import ContestMenu from "./ContestMenu/ContestMenu";
import ChangeLink from "../../../Elements/ChangeLink/ChangeLink";
import LayoutMain from "../../00LayoutMain/LayoutMain";
import SendQuestion from "../../00LayoutMain/TopMenu/SendQuestion/SendQuestion";
import TextChange from "../../../../AdminPart/src/Elements/TextChange/TextChange";

    function GatsbyContestIndexSource (props) {
        function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return <TextChange update={props.updateData} Text={InText} ArrIndex={info.ArrIndex} lang={props.lang} Adminka={true}/>
        } else {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}

        const MenuTop = [
        {Link : '/result/',Name : props.PrerenderTexts['ContestIndex0060'] ? JSON.parse(props.PrerenderTexts['ContestIndex0060'])[props.lang] : '*Результаты прошлых'},
        {Link : '/prizes/',Name : props.PrerenderTexts['ContestIndex0065'] ? JSON.parse(props.PrerenderTexts['ContestIndex0065'])[props.lang] : '*Получить приз'},
    ];

    return (
        <LayoutMain title={props.title} description={props.description} lang={props.lang}>
            <main className="ContestIndex StandartPage">
                <div className="StandartNOTitle"/>
                <div className="StandartWhitePart">
                    <div className="StandartWhitePartTitle">
                        <div className="StandartWhitePartTitleText">
                            <TextSource ArrIndex= 'ContestIndex0070'>Конкурсы</TextSource>
                        </div>
                        <SendQuestion lang={props.lang}/>
                    </div>
                </div>
                <ContestMenu lang={props.lang} Menu={MenuTop}/>
                <div className="TraderContest01Out">
                    <div className="TraderContest02">
                        {/*<img alt='alt' src={Open02Top}/>*/}
                        <ChangeLink lang={props.lang} to='/trader/contests/dailybitcoin/'><div className="TraderContest01Title"><TextSource ArrIndex= 'ContestIndex0035'>Ежедневный конкурс. Ты и биткоин</TextSource> </div></ChangeLink>
                        <div className="TraderContest01Text"><TextSource ArrIndex= 'ContestIndex0040'>Каждый участник конкурса получает 1 биткоин. Торговля происходит на конкурсном счете и вы должны максимально увеличить ваш баланс до конца дня</TextSource> </div>
                        <div className="TraderContest01PrizeTop"><TextSource ArrIndex= 'ContestIndex0045'>Призовой фонд каждого конкурса формируется из взносов участников. Взнос 0.5$</TextSource> </div>
                        <div className="TraderContest01Prize"> <TextSource ArrIndex= 'ContestIndex0050'>Взнос 0.5$</TextSource></div>
                        <div className="StandartButtonOut">
                            <ChangeLink to={'/trader/contests/dailybitcoin/'} lang = {props.lang}  style={{textDecoration: 'none'}}>
                                <div className={'ButtonBlue'}>
                                    <TextSource ArrIndex= 'ContestIndex0055'>Принять участие</TextSource>
                                </div>
                            </ChangeLink>
                        </div>
                    </div>
                </div>

            </main>
        </LayoutMain>

    )}

export default GatsbyContestIndexSource